<template>
    <div id="configDiv" class="vs-con-loading__container">

        <vx-card title="STB Config">

            <div class="vx-row">
                <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mt-6">
                    <h4>Home screen config</h4>

                    <vs-divider/>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <vs-checkbox class="mt-3" v-model="config['tv_enabled']">TV Enabled</vs-checkbox>
                        </div>
                        <div class="vx-col w-1/2">
                            <vs-checkbox class="mt-3" v-model="config['vod_enabled']">VOD Enabled</vs-checkbox>
                        </div>
                    </div>
                    <vs-divider/>
                    <p class="mt-6">TV Card text</p>
                    <vs-input v-model="config['tv_home_card_text']" class="w-full"/>

                    <div class="vx-row">
                        <div class="vx-col w-5/12">
                            <p class="mt-6">TV Card color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_home_card_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_home_card_color']"/>
                            </div>


                            <p class="mt-6 ">TV Card text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_home_card_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_home_card_text_color']"/>
                            </div>

                        </div>
                        <div class="vx-col w-7/12">
                            <vs-upload text="Upload TV card image" v-if="tvPictureEdit || config['tv_home_card_image'].length === 0" :automatic="true" limit="1" fileName="file" :action="'/api/management/v1/stb_config/image/home_screen_tv?subscriber_id=' + this.subscriberId" @on-success="homeScreenTvImageUploaded"/>
                            <div v-else @click="tvPictureEdit = true" class="cursor-pointer">
                                <p class="mt-6">TV Card image</p>
                                <img :src="'/api/management/v1/stb_config/image/' + config['tv_home_card_image']" class="p-6 rounded-lg" style="max-height: 200px">
                            </div>
                        </div>
                    </div>

                    <vs-divider/>

                    <p class="mt-6">VOD Card text</p>
                    <vs-input v-model="config['vod_home_card_text']" class="w-full"/>

                    <div class="vx-row">
                        <div class="vx-col w-5/12">
                            <p class="mt-6">VOD Card color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_home_card_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_home_card_color']"/>
                            </div>

                            <p class="mt-6 ">VOD Card text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_home_card_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_home_card_text_color']"/>
                            </div>
                        </div>
                        <div class="vx-col w-7/12">
                            <vs-upload text="Upload VOD card image" v-if="vodPictureEdit || config['vod_home_card_image'].length === 0" :automatic="true" limit="1" fileName="file" :action="'/api/management/v1/stb_config/image/home_screen_vod?subscriber_id=' + this.subscriberId" @on-success="homeScreenVODImageUploaded"/>
                            <div v-else @click="vodPictureEdit = true" class="cursor-pointer">
                                <p class="mt-6">VOD Card image</p>
                                <img :src="'/api/management/v1/stb_config/image/' + config['vod_home_card_image']" class="p-6 rounded-lg" style="max-height: 200px">
                            </div>
                        </div>
                    </div>

                    <vs-divider/>

                    <vs-upload text="Upload Home Screen image" v-if="homeScreenPictureEdit || config['home_screen_image'].length === 0" :automatic="true" limit="1" fileName="file" :action="'/api/management/v1/stb_config/image/home_screen_background?subscriber_id=' + this.subscriberId" @on-success="homeScreenImageUploaded"/>
                    <div v-else @click="homeScreenPictureEdit = true" class="cursor-pointer">
                        <h5 class="mt-6">Home screen image</h5>
                        <img :src="'/api/management/v1/stb_config/image/' + config['home_screen_image']" class="w-full rounded-lg mt-3">
                    </div>

                </div>
                <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mt-6">
                    <h4>TV Config</h4>

                    <vs-divider/>

                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <p class="mt-6">EPG Card color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_epg_card_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_epg_card_color']"/>
                            </div>

                            <p class="mt-6">EPG Main text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_epg_main_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_epg_main_text_color']"/>
                            </div>

                            <p class="mt-6">EPG Time text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_epg_time_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_epg_time_text_color']"/>
                            </div>

                            <p class="mt-6">EPG Progress bar color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_epg_progress_bar_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_epg_progress_bar_color']"/>
                            </div>

                            <p class="mt-6">Channel card color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_channel_card_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_channel_card_color']"/>
                            </div>
                        </div>
                        <div class="vx-col w-1/2">
                            <p class="mt-6">Channel text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_channel_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_channel_text_color']"/>
                            </div>

                            <p class="mt-6">Channel select background color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_channel_select_background_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_channel_select_background_color']"/>
                            </div>

                            <p class="mt-6">Basic EPG background color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_basic_epg_background_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_basic_epg_background_color']"/>
                            </div>

                            <p class="mt-6">TV Border color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['tv_border_color']"/>
                                <vs-input style="width: 90px" v-model="config['tv_border_color']"/>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mt-6">
                    <h4>VOD Config</h4>

                    <vs-divider/>

                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <p class="mt-6">VOD Lane color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_lane_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_lane_color']"/>
                            </div>

                            <p class="mt-6">VOD Search color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_search_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_search_color']"/>
                            </div>

                            <p class="mt-6">VOD Background color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_background_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_background_color']"/>
                            </div>

                            <p class="mt-6">VOD Card color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_card_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_card_color']"/>
                            </div>
                        </div>
                        <div class="vx-col w-1/2">
                            <p class="mt-6">VOD Card text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_card_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_card_text_color']"/>
                            </div>

                            <p class="mt-6">VOD Details text color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_details_text_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_details_text_color']"/>
                            </div>

                            <p class="mt-6">VOD Details lane color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_details_lane_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_details_lane_color']"/>
                            </div>

                            <p class="mt-6">VOD Details background color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['vod_details_background_color']"/>
                                <vs-input style="width: 90px" v-model="config['vod_details_background_color']"/>
                            </div>
                        </div>
                    </div>

                    <vs-divider/>

                    <h4>Loading screen config</h4>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <p class="mt-6">Background color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['loading_screen_background_color']"/>
                                <vs-input style="width: 90px" v-model="config['loading_screen_background_color']"/>
                            </div>
                        </div>
                        <div class="vx-col w-1/2">
                            <p class="mt-6">Loader color</p>
                            <div class="flex">
                                <input type="color" class="w-10 h-10 rounded-lg mr-2" v-model="config['loading_screen_loader_color']"/>
                                <vs-input style="width: 90px" v-model="config['loading_screen_loader_color']"/>
                            </div>
                        </div>
                    </div>

                    <vs-divider/>
                    <h4>MAG Images</h4>

                    <vs-divider/>
                    <div class="vx-row">
                        <div class="vx-col w-1/3">
                            <vs-checkbox class="mt-3" v-model="config['mag_channel_images']">Channels</vs-checkbox>
                        </div>
                        <div class="vx-col w-1/3">
                            <vs-checkbox class="mt-3" v-model="config['mag_epg_images']">Basic EPG</vs-checkbox>
                        </div>
                        <div class="vx-col w-1/3">
                            <vs-checkbox class="mt-3" v-model="config['mag_full_epg_images']">Full EPG</vs-checkbox>
                        </div>
                    </div>
                    <vs-divider/>

                    <h4>APP Build Version</h4>
                    <vs-input class="w-full mt-3" v-model="config['app_build_version']"/>

                    <vs-divider/>

                </div>
            </div>

            <vs-divider/>

            <vs-button @click="saveConfig">Save</vs-button>

        </vx-card>
    </div>
</template>
<script>

    export default {
        props: {
            subscriberId: {
                type: Number,
                required: false,
                default: 0
            }
        },
        data(){
            return {

                config: {
                    tv_home_card_image: "",
                    vod_home_card_image: "",
                    home_screen_image: "",
                },
                tvPictureEdit: false,
                vodPictureEdit: false,
                homeScreenPictureEdit: false,

            }
        },
        methods: {
            homeScreenTvImageUploaded(data){
                this.tvPictureEdit = false;
                this.config.tv_home_card_image = JSON.parse(data.target.response).image_id;
            },
            homeScreenVODImageUploaded(data){
                this.vodPictureEdit = false;
                this.config.vod_home_card_image = JSON.parse(data.target.response).image_id;
            },
            homeScreenImageUploaded(data){
                this.homeScreenPictureEdit = false;
                this.config.home_screen_image = JSON.parse(data.target.response).image_id;
            },
            loadData(){
                this.$vs.loading({
                    container: '#configDiv',
                    type: 'corners',
                    scale: 0.7
                })
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/stb_config/?subscriber_id=' + this.subscriberId)
                loadPromise.then(function(response) {
                    thisIns.config = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function () {
                    thisIns.$vs.loading.close('#configDiv > .con-vs-loading')
                })
            },
            saveConfig(){
                this.$vs.loading({
                    container: '#configDiv',
                    type: 'corners',
                    scale: 0.7
                })
                const thisIns = this
                const loadPromise = this.$http.put('/api/management/v1/stb_config/?subscriber_id=' + this.subscriberId, this.config)
                loadPromise.then(function() {
                    thisIns.$printSuccess("Config saved")
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function () {
                    thisIns.$vs.loading.close('#configDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        },

    }

</script>
